import React from "react";
import style from "./index.module.scss";
import { Icon, Modal, notification } from "antd";

import { ChatMessageItem } from "../../types";
import { useUpdateMessage } from "../../Utils/useUpdateMessage";
import { useSender } from "../../Utils/useSender";

interface RightMenuProps {
    msg: ChatMessageItem; //选中的消息
}

export const RightMenuOnOppositionText = ({ msg }: RightMenuProps) => {
    const updateMessage = useUpdateMessage();
    const sender = useSender();

    // 举报
    function onReport() {
        Modal.confirm({
            content: "确定要举报这条消息吗?",
            onOk: async () => {
                try {
                    sender.reportMessage(msg);

                    Modal.info({
                        content: "你的举报已经收到，经审核后我们会进行处理。"
                    });

                    updateMessage.updateMessage(msg.sessionUid, msg.guid, {
                        isAccused: "1"
                    });
                } catch (e) {
                    notification.info({
                        message: "网络错误, 消息发送失败",
                        placement: "bottomRight"
                    });
                }
            }
        });
    }

    return (
        <div className={style.root}>
            <div className={style.item} onClick={onReport} role="button">
                <Icon type="flag" className={style.icons} />
                举报
            </div>
        </div>
    );
};
